import { gql } from 'apollo-boost';

const manyQuery = gql`
  query {
    managers {
      id
      clubId
      firstName
      lastName
      middleName
      gender
      status
      types
      email
      permissions
      permissionsGymIds
      club {
        id
        shortName
      }
    }
  }
`;

const oneQuery = gql`
  query manager($id: Int!) {
    manager(id: $id) {
      id
      clubId
      firstName
      lastName
      middleName
      fullName
      email
      gender
      status
      types
      permissions
      permissionsGymIds
      address
      club {
        id
        shortName
      }
    }
  }
`;

export const createMutation = gql`
  mutation createManager($inputData: ManagerInputType!) {
    createManager(inputData: $inputData) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

export const updateMutation = gql`
  mutation updateManager($id: Int!, $inputData: ManagerInputType!) {
    updateManager(id: $id, inputData: $inputData) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

export const deleteMutation = gql`
  mutation deleteManager($id: Int!) {
    deleteManager(id: $id) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

export const paginatedManagersQuery = gql`
  query getPaginatedManagers($inputFilter: ManagersFilterInputObjectType) {
    paginatedManagers(inputFilter: $inputFilter) {
      items {
        id
        clubId
        firstName
        lastName
        middleName
        email
        gender
        status
        types
        club {
          id
          shortName
        }
      }
      pageInfo {
        total
      }
    }
  }
`;

const MANAGERS = {
  manyQuery,
  oneQuery,
  createMutation,
  updateMutation,
  deleteMutation,
  paginatedManagersQuery,
};

export default MANAGERS;
